export const checkout: object = {
  checkoutAddress: {
    shippingAddress: 'Lieferadresse',
    selectYourShippingAddress: 'Wählen Sie Ihre Lieferadresse',
    defaultShippingAddress: 'Standard-Versandadresse',
    verifyYourAddress: 'Überprüfen Sie Ihre Adresse',
    ensureAccuracySuggestChange:
      'Um die Genauigkeit der Lieferung zu gewährleisten, schlagen wir die unten ausgewählte Änderung vor.',
    chooseAddressToUse: 'Bitte wählen Sie, welche Adresse Sie verwenden möchten:',
    suggestedAddress: 'Vorgeschlagene Adresse',
    enteredAddress: 'Eingegebene Adresse',
    addNewAddress: 'Neue Adresse hinzufügen',
    shipToThisAddress: 'Senden Sie an diese Adresse',
    editAddress: 'Adresse bearbeiten',
    saveAddress: 'Adresse speichern',
  },
  checkoutOrderConfirmation: {
    confirmationOfOrder: 'Bestätigung der Bestellung:',
    thankYou: 'Vielen Dank für Ihre Bestellung!',
    invoiceHasBeenSentByEmail:
      'Es wurde eine Rechnung per E-Mail versandt. Sie sollten sie bald erhalten.',
    orderItems: 'Artikel bestellen',
    orderPlacedSuccessfully: 'Auftrag erfolgreich platziert',
    createAccount: 'Ein Konto erstellen?',
    createAccountForNext:
      'Erstellen Sie ein Konto für <{{email}}> für einen schnelleren Checkout bei Ihrem nächsten Besuch.',
    providedBy: 'Zur Verfügung gestellt von',
    sapStoreId: 'SAP Store ID:',
    your: 'Ihre',
    po: 'PO',
    hyphenNumber: '-Nummer:',
    purchaseOrder: 'Purchase Order',
  },
  checkoutReview: {
    orderItems: 'Auftragspositionen',
    confirmThatRead: 'Ich bestätige, dass ich das gelesen habe und damit einverstanden bin',
    placeOrder: 'Bestellung aufgeben',
    termsAndConditions: 'Bedingungen und Konditionen',
    editShippingAddress: 'Lieferadresse bearbeiten',
    editShippingMethod: 'Versandmethode bearbeiten',
    editPaymentMethod: 'Zahlungsmethode bearbeiten',
    review: 'Bestelldetails überprüfen',
    total: 'Gesamt:',
    totalWithTax: 'Gesamt mit Steuer:',
    estimatedTax: 'Geschätzte Steuer:',
    initialCost: 'Anfängliche Kosten:',
    initialCostTooltipTitle: 'View Initial cost details',
    initialCostTooltip: 'Für diese Lösung gibt es keine Vorabkosten. Sie werden nach Verbrauch abgerechnet.',
    importantTaxInfo: 'Important tax info',
    importantTaxInfoTooltip: 'This estimate is for informational purposes only and should not be considered definitive. Estimated tax may or may not be applied to your SAP invoice, depending on the specific terms of your transaction.',
    excludingTax: 'Steuer nicht inbegriffen',
    paymentSection: 'Zahlung',
    contactsSection: 'Vertragliche Kontaktes',
    summary: 'Preisübersicht',
    poNumber: 'PO-Nummer',
    startDateHasBeenUpdated: 'Das Startdatum für <strong>{{productName}} ({{productCode}})</strong> wurde zu <strong>{{date}}</strong> geändert weil das vorher ausgewählte Startdatum nicht länger gültig ist.',
    error: {
      orderHistoryProcessingNotFinished:
        {
          message: 'Your order is being processed, please wait for completion before starting a new order. If you have any questions, please ',
        },
      systemErrorTryAgainLater: {
        message: 'An error occurred while placing the order, please try again and contact us if the error persists.'
      },
      threeDsFailure: {
        message: 'An error occurred while processing 3DS challenge, use another payment method or try again.',
      },
      ccLimitExceeded: {
        message:
          'This transaction cannot be completed, as the amount exceeds our limit purchasable by credit card. Please change your payment' +
          ' method to invoice.',
        button: 'Edit Payment Method'
      },
      issueWithProduct: {
        message: 'It seems there’s been an issue with product in your cart. Please contact us to proceed.'
      },
      paymentRejected: {
        message: 'An error occurred while placing order, please verify credit card info and try again.'
      },
      stripeProcessing: {
        message:
          'We are currently facing issues processing payments.',
      },
      termsConditions: {
        message: 'Currently unable to display Terms and Conditions',
        secondaryMessage: 'We are working to resolve this issue. Please try again later.',
      },
      prerequisiteRequired: {
        message: 'Your current selection requires the following prerequisite(s). Please ensure your organization has licensed the required solutions or change your configuration.<br/><br/><b>{materialName} has prerequisites:</b><br/><br/><ul>'
      },
    },
    codes: {
      VAL_0001: 'We encountered an issue with your account. (Error Code: {{code}})',
      VAL_0002: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0003: 'We encountered an issue with your account. (Error Code: {{code}})',
      VAL_0004: 'Your account does not have buyer authorization. (Error Code: {{code}})',
      VAL_0005: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0006: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0007: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0008: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0009: 'We encountered an issue with your existing contracts. (Error Code: {{code}})',
      VAL_0010: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0011: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0012: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0013: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0014: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0015: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0016: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0017: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0018: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0019: 'We encountered an issue with the quantity value in your order(s). Please update the value(s) and try again. (Error Code: {{code}})',
      VAL_0020: 'The start date of (Product Name + ID) has been adjusted to (Today\'s date) as the previously defined start date is no longer valid. (Error Code: {{code}})',
      VAL_0021: 'We encountered an issue with the start date in your order(s). Please update the value(s) and try again. (Error Code: {{code}})',
      VAL_0022: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0023: 'We encountered an issue with the end date in your order(s). Please update the value(s) and try again. (Error Code: {{code}})',
      VAL_0024: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0025: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0026: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0027: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0028: 'The referenced contract item is outdated. Please remove the item from your cart, go back to SAP for Me and add it again. (Error Code: {{code}})',
      VAL_0029: 'We encountered an issue with the items in your cart. (Error Code: {{code}})',
      VAL_0030: 'We encountered an issue with the end date in your order(s). The end date is invalid. Please update the value(s) and try again. (Error Code: {{code}})',
      VAL_0031: 'We are missing your payment information for your order. Please add your payment details and try again. (Error Code: {{code}})',
      VAL_0046: 'Your organization currently has a buying restriction activated to prevent unauthorized purchases in the SAP Store. This can be granted to you by one of <a href="https://me.sap.com/userscontacts/impcont" target="_blank">your company’s administrators</a>. Please contact your company\'s administrator to obtain SAP Store purchasing authorization.',
      VAL_0048: 'We encountered an issue with the end date in your order(s). Please update the value(s) and try again. (Error Code: {{code}})',
      VAL_0100: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0101: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0102: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0103: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0104: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0105: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0500: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0501: 'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0502: 'We encountered an issue with your order. (Error Code: {{code}})',
    },
  },
  checkoutShipping: {
    shippingMethod: 'Versandart',
    standardDelivery: 'Standard-Lieferung',
    premiumDelivery: 'Premium-Zustellung',
  },
  checkout: {
    backToCart: 'Zurück zum Warenkorb',
    viewProviderDetails: '{{companyName}}, Anbieterdetails anzeigen',
    error: {
      contactUs: 'contact us',
      refreshPage: 'Seite neu laden',
      contactSupport: 'wenden Sie sich an den Support',
      singleProductNotLoaded: 'Konnte nicht richtig geladen werden',
      singleProductTryAgain: 'und erneut versuchen. Wenn das Problem weiterhin besteht',
      please: 'Bitte',
      singleProductRemoveFromCart: 'oder entfernen Sie den Artikel aus Ihrem Warenkorb.',
      multipleProductsNotLoaded: 'Die folgenden Elemente konnten nicht ordnungsgemäß geladen werden. Bitte aktualisieren Sie diese Seite. Wenn das Problem weiterhin besteht,',
      multipleProductsRemoveFromCart: 'oder entfernen Sie die Artikel aus Ihrem Warenkorb:',
      multipleProductsTryAgain: 'und erneut versuchen. Wenn das Problem weiterhin besteht',
      backEndCall: {
        message: 'Daten konnte nicht richtig geladen werden. Bitte',
        message1: 'Seite. Wenn das Problem weiterhin besteht,',
        contactSupport: 'wenden Sie sich an den Support.',
        refreshPage: 'aktualisieren Sie diese',
      }
    },
    additionalSolutions: 'Zusätzliche Erfoderliche Lösungen',
    groupTotal: 'Gruppen Summe',
    existingCustomerAgreement: 'Ihr bestehender Kundenvertrag enthält die folgenden Support-, Service- oder Lösungszusätze. Wenn Sie neue Lizenzen zu Ihrem Vertrag hinzufügen, werden diese unterstützenden Lösungen ebenfalls hinzugefügt.',
    allItemsInThisGroup: 'Für alle Elemente in dieser Gruppe',
    someItemsInThisGroup: 'Für einige Elemente in dieser Gruppe',
    for: 'Für',
    digitalNativeCheckout: {
      header: 'Secure Checkout',
      accountDetails: 'Account Details',
      buyerDetails: 'Buyer Details',
      personalDetails: 'Personal Details',
      companyDetails: 'Company Details',
      createNew: {
        contact: 'Create New Contact',
        technicalContact: 'Create New Technical Contact',
        billingContact: 'Create New Billing Contact',
        create: 'Create'
      },
      email: 'Business e-mail address',
      noContacts: 'No {{contactType}}s in the system',
      addTechnicalContact: 'Add Technical Contact',
      addTechnicalContactTooltip: 'Add a contact to this order who can allocate licenses to users, if required. This can be changed at any time by contacting SAP Store support.',
      addDifferentAccessLocationTooltip: 'Only contacts created in this checkout instance can be edited. For editing older contacts, please visit SAP4ME.',
      addTechnicalContactTooltipTitle: 'View technical contact details',
      addTechnicalContactConsent: 'Ich bestätige, dass ich die Genehmigung erhalten habe, diese Person bereitzustellen personenbezogene Daten an SAP.',
      technicalContact: 'Technical Contact',
      shipToAddress: 'The solution will primarily be accessed from a different location.',
      shipToAddressMessage: 'Dear Customer, Please verify the changes to the \'ship to\' contact and address. This action will affect your order.',
      primaryAccessLocation: 'Primary Access Location',
      payment: 'Payment',
      selectPayment: 'Select Payment Method',
      newContact: {
        type: 'Contact Type',
        typeOption: 'Assign {{type}} as the {{contact}}',
        department: 'a <strong>department</strong>',
        individual: 'an <strong>individual</strong>',
        error: {
          somethingWrong: 'Der Dienst ist derzeit nicht verfügbar. Bitte versuchen Sie es später noch einmal.',
          unexpectedEmailDomain: 'Die E-Mail-Adresse dieses Kontakts ist nicht in der Liste der zugelassenen Domains Ihres Unternehmens enthalten. Um eine neue Domain hinzuzufügen, kontaktieren Sie bitte den ',
          emailAlreadyExist: 'Der Kontakt, den Sie hinzufügen möchten, existiert bereits.',
          support: 'Support',
        }
      },
      newPrimaryAccessLocation: {
        heading: 'Create New Primary Access Location',
        submit: 'Create New Location',
        errors: {
          validation: 'Please check the information you provided and try again. If the problem persists, don’t hesitate to contact us.',
          generic: 'It seems there’s been an issue with our system. Please try again later. If the problem persists, don’t hesitate to contact us.',
        },
        tooltip: {
          address: 'Please provide the registered address of the company on whose behalf you are acting. This information will be used to identify the correct legal entity for contractual purposes and determine applicable taxes.'
        }
      },
      editAddress: {
        header: 'Edit Location',
        submitButton: 'Save',
        tooltip: {
          disabled: 'Only addresses created in this checkout instance can be edited. For editing older addresses please visit SAP4Me.'
        }
      },
      paymentType: {
        billingInformation: {
          title: 'Billing Information',
          billingContact: 'Billing Contact',
          billingAddress: 'Billing Address',
          tooltipTitle: 'View billing information details',
          tooltipContent: {
            title: 'Wie verwenden wir diese Abrechnungsinformationen?',
            firstLine: 'Die von Ihnen hier angegebenen Informationen werden auf Ihrer Rechnung ausgedruckt. Ihre endgültige Rechnung wird per E-Mail an Sie oder den von Ihnen angegebenen Rechnungskontakt gesendet.',
            secondLine: 'Sie können dieser Bestellung am Ende des Bestellvorgangs eine Kaufreferenz oder eine Bestellnummer hinzufügen.'
          }
        },
        invoice: {
          string: 'Invoice',
          info: 'You will be provided with an invoice from SAP including purchase details , SAP’s bank account information as well as the due date for the payment.',
        },
        cc: {
          string: 'Credit card',
          delegoInfo: 'All credit card data is securely processed by our partner Delego Software Inc. Ireland only under applicable data protection laws. Your Credit Card Information will be saved for future purchases.',
          stripeInfo: 'All credit card data is securely processed by our partner Stripe Payments Europe, Limited only under applicable data protection laws, this means your data may be transferred, processed and stored outside of your country and as set forth in the Stripe Privacy Policy ',
          cyberSourceInfo1: 'SAP uses a third-party payment processor, Cybersource, to process payments made to us via credit cards. Cybersource\'s data centers are in the USA and Singapore. In connection with the processing of such payments, we do not retain any personally identifiable information or any financial information such as credit card account numbers. Rather, all such information is provided directly by you to Cybersource, whose use of your personal information is governed by their Data Processing Agreement which can be found here: ',
          cyberSourceInfo2: ' SAP will never receive your card account number, not even in encrypted form. SAP\'s merchant activities are certified annually by a recognized PCI auditor as PCI-DSS compliant.',
          cyberSourcePrivacyLink: 'https://www.cybersource.com/en-us/about/dpa.html',
          stripePostponedCharge: 'Your credit card will be charged on the contract start date you have selected.',
          stripePrivacyLink: 'https://stripe.com/privacy',
          stripeDisclosure: 'may be subject to disclosure as required by applicable laws. Your tokenized Credit Card Information will be saved for future purchases and recurring/subscription payments.',
          error: 'Bitte gültige Kreditkartendaten eingeben',
          note: 'Note: ',
          disclaimer: 'To verify your credit card, we will request a temporary authorization of 1 {{currencyIso}} on your card. Your credit card will not be charged.',
          dropdown: {
            cardNumberHidden: '****',
            addNewCard: 'Add new Card',
          },
          cancelButton: 'Cancel',
          maintenance: 'Credit Card payments not available from {{startDate}} to {{endDate}} due to system maintenance.',
          errors: {
            sessionExpired: 'Your session has expired. We have created a new one for you.',
            cyberSource: {
              authenticationFailed: 'Authentication failed. Please try again.',
              ccNumber: {
                incomplete: 'Your Card Number is incomplete',
                invalid: 'Your Card Number is invalid',
              },
              expirationDate: {
                incomplete: 'Expiration Date is incomplete',
                inThePast: 'Expiration Date can not be in the past',
                monthInvalid: 'Expiration month is invalid',
              },
              securityCode: {
                incomplete: 'Your Card Security Code is incomplete'
              },
            }
          }
        },
      },
      tax: {
        taxHeader: 'Tax Information',
        vatNumber: 'VAT Number',
        taxId: 'Tax ID',
        taxTooltipTitle: 'View TaxID details',
        taxTooltip: 'Anhand dieser Angaben wird der für diese Bestellung geltende Steuersatz ermittelt.',
        taxExemption: 'I would like to add a tax exemption document provided from my company to this order.',
        fileUploadingInformationWarning1: 'Please read the ',
        fileUploadingInformationLink: 'information',
        fileUploadingInformationWarning2: ' before adding the file',
        dragDropHere: 'Drag and drop your file here',
        or: 'or',
        button: 'Choose File',
        remove: 'Remove File',
        modal: {
          popUpHeader: 'Tax Exempt Rules and Information'
        },
        errors: {
          fileSize: 'File size too large. Please upload a file 5MB or smaller.',
          fileType: 'File type not supported. Please upload a PDF, image or Microsoft Office file.',
          countLimit: 'Maximum 1 file is allowed.',
          fileInfected: 'File is invalid. Please upload a different file.',
          max: 'Bitte geben Sie einen numerischen Wert mit maximal 15 Nachkommastellen ein.',
          taxTooltipFormat: 'Format:',
          taxValidation: 'Beim Überprüfen Ihrer Steuerinformationen ist ein Fehler aufgetreten. Bitte stellen Sie sicher, dass es das richtige Format hat:',
          taxValidationSystem: 'Ihre Steuerinformationen konnten derzeit nicht validiert werden. Bitte versuchen Sie es in Kürze erneut.',
          taxValidationReviewOrder: 'Beim Überprüfen Ihrer Steuerinformationen ist ein Fehler aufgetreten.'
        },
        warnings: {
          noAttachments: 'Bitte laden Sie Ihr Steuerbefreiungsdokument hoch'
        }
      },
    },
  },
  checkoutProgress: {
    shippingAddress: 'Lieferadresse',
    deliveryMode: 'Zustellungsmodus',
    paymentDetails: 'Zahlungsdetails',
    reviewOrder: 'Überprüfungsauftrag',
  },
};
